import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const SmallMenuButton = ({ title, menuOptions, buttonLink, navigateTo }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = (e) => {
    if (!menuOptions) {
      return;
    }
    setIsOpen(e);
  };

  const handleOptionClick = (item, e) => {
    handleOpenChange(e);
    if (item) {
      navigateTo(item.link, item.linkType);
    }
  };

  return (
    <Container>
      <HeaderBtn
        isOpen={isOpen}
        onClick={() => handleOptionClick(buttonLink, !isOpen)}
      >
        {title}
      </HeaderBtn>
      {isOpen && menuOptions && (
        <AnimatePresence>
          <>
            <MenuContent
              initial={{ height: 0 }}
              animate={{ height: "auto" }}
              exit={{ height: 0 }}
              transition={{ duration: 0.4 }}
            >
              {menuOptions?.map((option, index) => (
                <Category key={index}>
                  {option.categoryTitle && <h2>{option.categoryTitle}</h2>}
                  {option.categoryItems.map((item, inedx) => (
                    <MenuOption
                      key={item.title}
                      onClick={() => handleOptionClick(item, false)}
                    >
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                    </MenuOption>
                  ))}
                </Category>
              ))}
            </MenuContent>
          </>
        </AnimatePresence>
      )}
    </Container>
  );
};

export default SmallMenuButton;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const HeaderBtn = styled.button`
  display: flex;
  align-items: center;
  border: none;
  cursor: pointer;
  color: ${lightThemeColors.darkColor};
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
  position: relative;
  width: 100%;
  padding: 20px 0;
  border-bottom: 1px solid ${lightThemeColors.borderColor};
  background: unset;
`;

const MenuContent = styled(motion.div)`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  z-index: 100;
  padding: 10px 0;
  gap: 30px;
`;

const MenuOption = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px 20px;
  border-radius: 4px;
  border-bottom: 1px solid ${lightThemeColors.darkColorFullFaded};
  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${lightThemeColors.darkColorFullFaded};
  }
  cursor: pointer;
  h3 {
    color: ${lightThemeColors.darkColor};
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
  }
  p {
    color: ${lightThemeColors.darkColorFaded};
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
  }
`;
const Category = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  h2 {
    padding: 0 5px;
    color: ${lightThemeColors.header.categoryTypeColor};
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
  }
`;
